import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function upsertMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export default function Seo({ title, description, jsonLd }) {
    const location = useLocation();
    const origin = window.location.origin;
    const url = `${origin}${location.pathname}`;

    useEffect(() => {
        if (title) {
            document.title = title;
            upsertMeta("property", "og:title", title);
        }
        if (description) {
            upsertMeta("name", "description", description);
            upsertMeta("property", "og:description", description);
        }
        upsertMeta("property", "og:url", url);
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", url);
        let script;
        if (jsonLd) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.id = "page-jsonld";
            script.text = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
        return () => {
            const el = document.getElementById("page-jsonld");
            if (el) el.remove();
        };
    }, [title, description, url, jsonLd]);

    return null;
}
